// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageSection_wrapper__10kFO","border_blur":"ImageSection_border_blur__2JlLN"};